import {
  FETCHING_COLLECTIONS_COUNT,
  FETCHING_COLLECTIONS_COUNT_SUCCEEDED,
  FETCHING_COLLECTIONS_COUNT_FAILED,
  MIGRATING_COLLECTIONS,
  MIGRATINGCOLLECTIONS_SUCCEEDED,
  MIGRATINGCOLLECTIONS_FAILED
} from "constants/actionTypes";

const initState = {
  count: {
    all: {
      fetching: false,
      total: 0,
      error: null,
    },
  },
  transfer: {
    updating: false,
    success: false,
    error: null,
  }
};

function collectionsReducer(state = initState, action) {

  switch (action.type) {
    case FETCHING_COLLECTIONS_COUNT: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          all: { fetching: true, total: 0, error: null },
        },
      });
    }

    case FETCHING_COLLECTIONS_COUNT_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          all: { fetching: false, total: action.payload, error: null },
        },
      });
    }

    case FETCHING_COLLECTIONS_COUNT_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;

      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          all: { fetching: false, total: 0, error: error },
        },
      });
    }
    case MIGRATING_COLLECTIONS:
      return Object.assign({}, state, {
        ...state,
        transfer: {
          updating: true,
          success:false,
          error:null
        },
      });
    case MIGRATINGCOLLECTIONS_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        transfer: { updating: false, success: true, error: null },
      });
    case MIGRATINGCOLLECTIONS_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        transfer: {
          updating: false,
          success: false,
          error: error,
        },
      });
    }

    default:
      return state;
  }
}

export { collectionsReducer };
